import React from 'react';

import Loader from 'react-spinners/CircleLoader';

import AppLayout from "../application/AppLayout";
import {useSelector} from "react-redux";

import {styled, Grid, Paper, Typography, useTheme} from '@mui/material';

const PREFIX = 'AppLoading';

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    title: `${PREFIX}-title`
};

const StyledAppLayout = styled(AppLayout)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
      flexGrow: 1,
      height: '100%',
    },

    [`& .${classes.paper}`]: {
      width: '360px',
      height: '220px',
    },

    [`& .${classes.title}`]: {
      paddingTop: '16px'
    }
}));

export default function AppLoadingComponent({title, message}) {

    const theme = useTheme();

  	const cssOverride = `
		display: block;
		margin-left: 130px;
		margin-top: 0px
	`;

    return (
        <StyledAppLayout>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{
                    minHeight: 'calc(100% - 64px)',
                    backgroundColor: 'rgba(0,0,0,0)',
                }}
            >
                <Grid item xs={12}>
                    <Paper className={classes.paper} style={{width: '360px', height: '220px'}}>
                        <div
                        style={{
                        height: '60px',
                        width: 'calc(100% - 32px)',
                        padding: '16px',
                        textAlign: 'center',
                        }}
                        >
                            <Loader
                                css={cssOverride}
                                sizeUnit={'px'}
                                size={54}
                                color={theme.palette.primary[500]}
                                loading={true}
                            />
                        </div>
                        <div
                            style={{
                            width: '100%',
                            height: 'calc(100% - 60px)',
                            textAlign: 'center',
                            padding: '8px',
                            }}
                        >
                            {!title &&
                                <Typography className={classes.title} style={{paddingTop: '16px'}} variant="h6" gutterBottom>
                                    Please wait...
                                </Typography>
                            }
                            {title &&
                                <Typography className={classes.title} style={{paddingTop: '16px'}} variant="h6" gutterBottom>
                                    {title}
                                </Typography>
                            }
                            {!message &&
                                <Typography variant="body2" gutterBottom>
                                    Sit tight while we load up the projects, maps, charts, models and configure the
                                    application <span style={{fontWeight: 'bold'}}>:)</span>
                                </Typography>
                            }
                            {message &&
                                <Typography variant="body2" gutterBottom>
                                    {message}
                                </Typography>
                            }
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </StyledAppLayout>
    );
}
